import moment from "moment";

export function formatDate(date: Date) {
  if (!moment(new Date()).isSame(date, "day")) {
    return moment(date).format("DD MMM");
  } else {
    return moment(date).format("LT");
  }
}
